import { FormHelperText } from '@mui/material'

import { useTexts } from '../../hooks/useTexts'

import { form } from '../formState'

export function Pods() {
  const texts = useTexts()

  return (
    <form.Fieldset>
      <form.SectionSubtitle variant="body1">{texts.podsTitle}</form.SectionSubtitle>
      <form.Checkbox
        name="showPicturePod"
        testId="showPicturePod"
        label={texts.picture}
        validateOn="focus blur"
      />
      <form.Checkbox
        name="showSignaturePod"
        testId="showSignaturePod"
        label={texts.signature}
        validateOn="focus blur"
      />
      <form.Checkbox
        name="showAudioPod"
        testId="showAudioPod"
        label={texts.voiceMemo}
        validateOn="focus blur"
      />
      <form.Checkbox
        name="showNotePod"
        testId="showNotePod"
        label={texts.driverNote}
        validateOn="focus blur"
      />
      <FormHelperText>{texts.podsHelperText}</FormHelperText>
    </form.Fieldset>
  )
}
